import 'lightgallery';

$(function () {
    $('.js-gallery').lightGallery({
        selector: 'a',
        download: false
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery.js
// module id = 11
// module chunks = 0